export const categories = [
  {
    id: "works",
    name: "作品集",
    icon: "ri-movie-line",
    description: "苍井樱经典作品回顾与精选推荐",
    count: 48,
  },
  {
    id: "gallery",
    name: "图片集",
    icon: "ri-image-line",
    description: "苍井樱高清写真与活动照片",
    count: 156,
  },
  {
    id: "news",
    name: "新闻动态",
    icon: "ri-newspaper-line",
    description: "苍井樱最新资讯与活动报道",
    count: 89,
  },
  {
    id: "discussion",
    name: "粉丝热议",
    icon: "ri-chat-1-line",
    description: "粉丝社区热门话题与讨论",
    count: 234,
  },
  {
    id: "interview",
    name: "专访报道",
    icon: "ri-mic-line",
    description: "苍井樱独家访谈与深度报道",
    count: 27,
  },
  {
    id: "video",
    name: "视频专区",
    icon: "ri-video-line",
    description: "苍井樱精彩视频内容合集",
    count: 63,
  },
];